module.exports = __webpack_public_path__ + "static/media/baseline-add-24px.ca3efbf7.svg";